import { Component, signal } from '@angular/core';

interface Faq {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faqs',
  standalone: true,
  templateUrl: './faqs.html',
  styleUrl: './faqs.scss',
})
export class FaqsComponent {
  openIndex = signal<number | null>(0);

  faqs: Faq[] = [
    {
      question: '¿Cuál es el precio del taller?',
      answer: 'El precio varía según el tipo de experiencia. En cada taller encontrarás toda la información detallada antes de reservar.\n\nLas plazas son limitadas para mantener grupos reducidos y una experiencia cuidada.',
    },
    {
      question: '¿Se incluyen los materiales?',
      answer: 'Todos los materiales están incluidos en el taller. Trabajamos con diferentes herramientas y soportes según la experiencia, siempre seleccionados para facilitar el proceso creativo y hacerlo accesible para cualquier persona.',
    },
    {
      question: '¿Incluye merienda o algo para tomar?',
      answer: 'Sí, en muchos talleres incluimos una pequeña merienda o algo para acompañar la experiencia. Queremos que sea un momento para parar, así que cuidamos también esos detalles.',
    },
    {
      question: '¿Necesito tener experiencia previa?',
      answer: 'No necesitas experiencia artística. Las dinámicas están pensadas para acompañarte paso a paso, sin presión ni expectativas, para que puedas centrarte en el proceso y en lo que vas sintiendo.',
    },
    {
      question: '¿Cómo es el ambiente de los talleres?',
      answer: 'Trabajamos en grupos reducidos para crear un espacio cercano y tranquilo, donde puedas sentirte cómodo, desconectar del ritmo diario y vivir la experiencia sin presión. Las plazas son limitadas para mantener grupos reducidos y una experiencia cuidada.',
    },
  ];

  toggle(index: number) {
    this.openIndex.update(i => (i === index ? null : index));
  }

  scrollToContact() {
    const el = document.getElementById('contacto');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
